import type { Asset } from '../types/Asset';

/**
 * Returns a new array of assets sorted alphabetically by display label
 * (name, then description, then asset number). Leading non-alphanumeric
 * characters (e.g. "(#") are stripped so they don't push entries before
 * alphabetically-named ones. Tie-break by id for stable order.
 * Does not mutate the input array. Returns [] if assets is not an array.
 */
export function sortAssetsAlphabetically(assets: Asset[]): Asset[] {
  if (!Array.isArray(assets)) return [];
  const getLabel = (asset: Asset): string => {
    const raw = (asset.name || asset.description || asset.assetNumber || '').trim();
    return raw.replace(/^[^a-zA-Z0-9]+/, '').toLowerCase();
  };
  return [...assets].sort((a, b) => {
    const comparison = getLabel(a).localeCompare(getLabel(b), undefined, { sensitivity: 'base' });
    if (comparison !== 0) return comparison;
    return String(a.id ?? '').localeCompare(String(b.id ?? ''));
  });
}
